import { render, staticRenderFns } from "./UiPrediction.vue?vue&type=template&id=8c4fae80&lang=pug&"
import script from "./UiPrediction.vue?vue&type=script&lang=js&"
export * from "./UiPrediction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports